import { createSlice } from '@reduxjs/toolkit';

import { getLessonRatings, getLessonRatingsByStudentId } from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 50,
};

const lessonRatingsSlice = createSlice({
  name: 'lessonRatings',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getLessonRatings.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(
      getLessonRatingsByStudentId.fulfilled,
      (_: any, action: any) => {
        return action.payload;
      },
    );
  },
});

export default lessonRatingsSlice.reducer;
